import { render, staticRenderFns } from "./ListTicketMessages.vue?vue&type=template&id=6f95b416"
import script from "./ListTicketMessages.vue?vue&type=script&lang=js"
export * from "./ListTicketMessages.vue?vue&type=script&lang=js"
import style0 from "./ListTicketMessages.vue?vue&type=style&index=0&id=6f95b416&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports